import axiosHttp from "services/axiosHttp";

// Invoice Service Functions
export const invoiceService = {
  // Create invoice
  createInvoice: async (data) => {
    const response = await axiosHttp.post("/pmo/invoice", data);
    return response.data;
  },

  // Get invoice list with optional params
  getInvoiceList: async (params = {}) => {
    const response = await axiosHttp.get("/pmo/invoice", { params });
    return response.data;
  },

  // Get single invoice by ID
  getInvoice: async (id) => {
    const response = await axiosHttp.get(`/pmo/invoice/${id}`);
    return response.data;
  },

  // Get PI LIST
  getPIList: async (params = {}) => {
    const response = await axiosHttp.get("/pmo/pi/list", { params });
    return response.data;
  },


  // Update invoice
  updateInvoice: async (id, data) => {
    const response = await axiosHttp.put(`/pmo/invoice/${id}`, data);
    return response.data;
  },

  // Delete invoice
  deleteInvoice: async (id) => {
    const response = await axiosHttp.delete(`/pmo/invoice/${id}`);
    return response.data;
  },
};

